<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiEyeOff } from "@mdi/js";
export default {
  name: "MdiEyeOff",
  data() {
    return {
      svgPath: mdiEyeOff,
    };
  },
};
</script>
